









import Vue from 'vue';
import trip from '@/store/modules/trip';
import FeedMessage from "@/components/FeedMessage.vue";
import Component from 'vue-class-component';

@Component({
  components: {
    FeedMessage
  }
})
export default class Feed extends Vue {

  get feedItems() {
    return trip.feed;
  }

}
